@let requestsMaxFileSize = requestsMaxFileSize$ | async;
@let requestsMaxFileSizeAllDocuments = requestsMaxFileSizeAllDocuments$ | async;

<div>
    <form [formGroup]="form" [class.eui-editor-full-screen]="isFullScreen">
        <eui-editor formControlName="content" isMinimalToolbar
                    (editorCreate)="onEditorCreated($event)">
                    (focus)="clickInsideReplyBox()"
                    (blur)="clickOutsideReplyBox()"
                    (keyup)="_keyUp()" format="html"
                    [placeholder]="placeholder | translate"
                    class="ecl-u-width-100"
                    [class.ecl-u-height-100]="isFullScreen"
                    (contentChange)="onChangeMessage($event)">
            <euiEditorCustomToolbar class="custom-editor-container">
                <span class="ql-formats">
                    <button [title]="'Undo'" (click)="undoChanges()">
                        <eui-icon-svg icon="eui-arrow-undo:eui" size="s"/>
                    </button>
                    <button [title]="'Redo'" (click)="redoChanges()">
                        <eui-icon-svg icon="eui-arrow-redo:eui" size="s"/>
                    </button>
                </span>
                <span class="ecl-u-width-0 ecl-u-height-100 ecl-u-border-left ecl-u-border-color-dark-60"></span>
                <span class="ql-formats">
                    <button class="ql-bold" [title]="'Bold'"></button>
                    <button class="ql-italic" [title]="'Italics'"></button>
                    <button class="ql-underline" [title]="'Underline'"></button>
                </span>
                <span class="ecl-u-width-0 ecl-u-height-100 ecl-u-border-left ecl-u-border-color-dark-60"></span>
                <span class="ql-formats">
                    <button class="ql-list" value="bullet" [title]="'Bullet-List'"></button>
                    <button class="ql-list" value="ordered" [title]="'Ordered-List'"></button>
                    <button class="ql-indent" value="-1" [title]="'Decrease Indent'"></button>
                    <button class="ql-indent" value="+1" [title]="'Increase Indent'"></button>
                </span>
                <span class="ql-formats fullscreen-button">
                    <button [title]="'Fullscreen'"
                            (click)="isFullScreen = !isFullScreen">
                        <eui-icon-svg icon="eui-ecl-fullscreen:eui" size="s"/>
                    </button>
                </span>
            </euiEditorCustomToolbar>
        </eui-editor>
        <section *ngIf="isOnCommunication || ( content && isClickInsideReplyBox)">
            <span *ngIf="savedAsDraftTime" class="ecl-u-type-s ecl-u-mt-m"
                  [innerHTML]="'easeportal.editor.AUTOMATICALLY-SAVED-AS-DRAFT' | translate"> </span>
                {{savedAsDraftTime | date: 'hh:mm a'}}

            <div eclHelpBlock>
                <div class="ecl-u-mt-xs ecl-u-mb-m ecl-u-type-color-grey-75"
                     [innerHTML]="'easeportal.document-details.FILE-HELP-MESSAGE' | translate : {
                    maximumFileSize: requestsMaxFileSize | appFormatBytes,
                    totalMaximumFileSize: requestsMaxFileSizeAllDocuments | appFormatBytes
                }">
                </div>
            </div>

            <!-- File Upload component -->
            @if (isOnCommunication) {
            <div class="ecl-u-d-flex ecl-u-justify-content-end">
                <input #fileInput id="attachmentsFiles"
                       type="file" multiple [hidden]="true"
                       (change)="onFilesSelected($event)"
                       accept=".docx,.pdf,.odt,.rtf,.txt,.doc">
                <button eclButton variant="primary" (click)="fileInput.click()">{{ 'easeportal.communication.ADD-ATTACHMENTS' | translate }}</button>
            </div>
            }
            @if (attachmentsArrayControl.value.length > 0) {
            <div class="ecl-u-mt-m ecl-u-mb-m" formArrayName="attachments">
                <strong>{{ 'easeportal.case.ATTACHMENTS' | translate }}</strong><br>
                @for(attachment of attachmentsArrayControl.value; track $index; let i = $index) {
                <div class="ecl-u-d-flex ecl-u-border-bottom ecl-u-border-color-primary-20 ecl-u-pv-s">
                    <div class="ecl-col-8 ecl-u-align-self-center attachment-name">
                        <a eclLink variant="standalone" class="eui-ecl-u-cursor-pointer" (click)="downloadFile(attachment)">{{ attachment.name }}</a>
                        @let errors = attachmentsArrayControl.controls[i]?.errors || {};
                        @if (!!errors.max_file_size) {
                        <div class="attachment-error">
                            <ecl-icon icon="error" size="s" ariaHidden="false" role="img"></ecl-icon>
                            <div class="ecl-u-ml-xs" [innerHTML]="'easeportal.validation.document.MAXIMUM-FILE-SIZE' | translate : {
                        maximumFileSize: requestsMaxFileSize | appFormatBytes
                        }"></div>
                                    </div>
                        }
                        @else if (!!errors.protected) {
                        <div class="attachment-error">
                            <ecl-icon icon="error" size="s" ariaHidden="false" role="img"></ecl-icon>
                            <div class="ecl-u-ml-xs" translate="easeportal.validation.document.encrypted"></div>
                        </div>
                        }
                    </div>
                    <div class="ecl-col-3 ecl-u-align-self-center">{{ attachment.size | appFormatBytes }}</div>
                    <div class="ecl-col-1 ecl-u-align-self-center">
                        <button eclButton variant="ghost" isIconOnly (click)="deleteFile(i)">
                            <ecl-icon icon="close-outline" size="m"></ecl-icon>
                        </button>
                    </div>
                </div>
                }
            </div>
            }

            <div class="ecl-u-d-flex ecl-u-justify-content-between ecl-u-mt-m">
                <div>
                    <button eclButton variant="secondary" class="ecl-u-mt-m ecl-u-mr-m" (click)="discardDraft()">
                        {{ 'easeportal.editor.DISCARD' | translate}}
                    </button>
                </div>
                <div>
                    <button eclButton variant="secondary" class="ecl-u-mt-m" (click)="saveAsDraftMessage()"
                            [disabled]="!form.valid">
                        {{ 'easeportal.communication.SAVE-AS-DRAFT' | translate}}
                    </button>
                    <button eclButton variant="primary" class="ecl-u-mt-m ecl-u-ml-s" (click)="sendAnswer()" *ngIf="isOnCommunication;"
                            [disabled]="!form.valid">
                        {{ 'easeportal.communication.SEND' | translate}}
                    </button>
                </div>
            </div>
        </section>
    </form>
</div>
